import { Component } from '@angular/core';

/* Footer displayed on each page */
@Component({
	selector: 'app-footer',
	styleUrls: ['./footer.component.scss'],
	templateUrl: 'footer.component.html'
})
export class FooterComponent {}
